export default __webpack_public_path__ + "static/image-2021-12-22-10-02-22-590-c7eb9472588a5f7db39871f52418aaf8.png";